/* Elford Lane – sticky add to cart: bottom bar, appears after scrolling 30% of the screen past the main button,
   and hides while any drawer is open (cart, menu, search, size guide, zoom). */
const bar = document.querySelector('[data-el-sticky]');
if (bar) {
  const pdp = document.querySelector(`[data-el-product][data-section="${bar.dataset.elSticky}"]`);
  const atc = pdp && pdp.querySelector('.el-buy [data-el-atc]');
  let past = false;
  let overlay = false;
  const update = () => bar.classList.toggle('is-shown', past && !overlay);

  if (atc) {
    // Root grown 30% above the viewport: the button must be 30% of a screen above the top before the bar shows.
    const io = new IntersectionObserver(([en]) => {
      past = !en.isIntersecting && en.boundingClientRect.top < 0;
      update();
    }, { rootMargin: '30% 0px 0px 0px' });
    io.observe(atc);
  }

  // Horizon drawers set [open] on <theme-drawer>; our own drawers are <dialog class="el-drawer|el-zoom">.
  const OPEN = 'theme-drawer[open], .el-drawer[open], .el-zoom[open], dialog[open]:modal';
  const checkOverlay = () => {
    let open = false;
    try { open = !!document.querySelector(OPEN); } catch (e) { open = !!document.querySelector('theme-drawer[open], .el-drawer[open], .el-zoom[open]'); }
    overlay = open;
    document.body.classList.toggle('el-overlay-open', overlay);
    update();
  };
  new MutationObserver(checkOverlay).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
  checkOverlay();
}
